module.exports = __webpack_public_path__ + "static/thpcbear1-1ee5e262e1c97091cb94452a140d7d74.jpeg";